//@ts-check
import { imgify } from '../misc';

/**
 * @typedef {{src:string}[]} imagebase
 */

/**
 * A list of achievement pictures
 * @type {imagebase}
 */
export const achievements = [
  {src: imgify`fp/achievements/9.jpg` },
  { src: imgify`fp/achievements/1.JPG` },
  { src: imgify`fp/achievements/2.JPG` },
  { src: imgify`fp/achievements/3.JPG` },
  { src: imgify`fp/achievements/10.JPG` },
  { src: imgify`fp/achievements/4.JPG` },
  { src: imgify`fp/achievements/5.JPG` },
  { src: imgify`fp/achievements/6.JPG` },
  { src: imgify`fp/achievements/7.JPG` },
  { src: imgify`fp/achievements/8.JPG` },
  
];

/**
 * a list of pictures describing what we do
 * @type {imagebase}
 */
export const whatWeDo = [
  { src: imgify`fp/whoweare/IMG_20200222_095939.jpg` },
  { src: imgify`fp/whoweare/IMG_20200222_173629.jpg` },
];
